export default __webpack_public_path__ + "static/assets/no_pills_mask.83f43885.png";